<template>
  <div>
    <PageHeaderLayout>
      <div class='main-page-content'>
        <el-row class='table-header'>
          <el-col :span='1.5'>
            <el-button v-if="userPermissions.indexOf('category_create') != -1" type='primary' icon='el-icon-plus'
                       @click='addButton({})'>添加主分类
            </el-button>
          </el-col>
        </el-row>
        <div v-loading='loadingStatus'
             element-loading-text="加载中……"
             element-loading-spinner="el-icon-loading">
          <el-table :data='categoryList'

                    row-key='id'
                    :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                    border>
            <el-table-column label='序号' type='index' width='55'></el-table-column>
            <el-table-column label='分类' prop='display_name'></el-table-column>
            <el-table-column label='唯一标识' prop='name'></el-table-column>
            <el-table-column label='排序值' prop='order' width='100'></el-table-column>
            <el-table-column
              align='center'
              width='220'
              label='操作'>
              <template slot-scope='scope'>
                <el-tooltip effect='dark' content='添加子分类' placement='top-start'
                            v-if="userPermissions.indexOf('category_create') !== -1">
                  <el-button size='mini' type='text' icon='el-icon-plus'
                             @click='addButton(scope.row)'>追加
                  </el-button>
                </el-tooltip>
                &nbsp;
                <el-tooltip effect='dark' content='编辑' placement='top-start'
                            v-if="userPermissions.indexOf('category_edit') !== -1">
                  <el-button type='text' size='mini' icon='el-icon-edit' @click='editButton(scope.row)'>编辑</el-button>
                </el-tooltip>
                &nbsp;
                <el-tooltip effect='dark' content='删除' placement='top-start'>
                  <el-link type='danger' size='mini' icon='el-icon-close' @click='handleDelete(scope.row)'>删除
                  </el-link>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!--        <TreeTable :data='categoryList' :columns='columns' :loading='loadingStatus' ref='treeTable'-->
        <!--                   highlight-current-row>-->
        <!--          <el-table-column-->
        <!--            slot='first-column'-->
        <!--            width='160'-->
        <!--            align='center'-->
        <!--            label='Drag'>-->
        <!--            <template slot-scope='scope'>-->
        <!--              <el-tooltip effect='dark' content='拖动排序' placement='top-start'>-->
        <!--                <span class='drag-handle' :data-id='scope.row.id' :data-parent_id='scope.row.parent_id'-->
        <!--                      :data-depth='scope.row.depth'><i class='el-icon-rank'></i></span>-->
        <!--              </el-tooltip>-->
        <!--            </template>-->
        <!--          </el-table-column>-->
        <!--          <el-table-column-->
        <!--            align='center'-->
        <!--            width='220px'-->
        <!--            label='操作'>-->
        <!--            <template slot-scope='scope'>-->
        <!--              <el-tooltip effect='dark' content='添加子分类' placement='top-start'-->
        <!--                          v-if="userPermissions.indexOf('category_create') !== -1">-->
        <!--                <el-button size='mini' type='text' icon='el-icon-plus'-->
        <!--                           @click='addButton(scope.row.id)'></el-button>-->
        <!--              </el-tooltip>-->
        <!--              &nbsp;-->
        <!--              <el-tooltip effect='dark' content='编辑' placement='top-start'-->
        <!--                          v-if="userPermissions.indexOf('category_edit') !== -1">-->
        <!--                <el-button type='text' size='mini' icon='el-icon-edit' @click='editButton(scope.row.id)'></el-button>-->
        <!--              </el-tooltip>-->
        <!--              &nbsp;-->
        <!--              <el-tooltip effect='dark' content='删除' placement='top-start'>-->
        <!--                <span>-->
        <!--                  <el-popover-->
        <!--                    v-if="userPermissions.indexOf('category_delete') !== -1"-->
        <!--                    placement='top'-->
        <!--                    width='150'-->
        <!--                    v-model='scope.row.visible'>-->
        <!--                    <p>确定要删除记录吗？</p>-->
        <!--                    <div style='text-align: right; margin: 0;'>-->
        <!--                      <el-button type='text' size='mini' @click='scope.row.visible=false'>取消</el-button>-->
        <!--                      <el-button type='danger' size='mini' @click='deleteButton(scope.row.id)'>确定</el-button>-->
        <!--                    </div>-->
        <!--                    <el-button slot='reference' type='text' size='mini' icon='el-icon-delete'></el-button>-->
        <!--                  </el-popover>-->
        <!--                </span>-->
        <!--              </el-tooltip>-->
        <!--            </template>-->
        <!--          </el-table-column>-->
        <!--        </TreeTable>-->
      </div>
    </PageHeaderLayout>
    <!--    编辑框-->
    <CreateEdit ref='refCreateEdit' @saved='handleSavedEvent' />
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import TreeTable from '@/components/TreeTable'
import Sortable from 'sortablejs'
import ModalDialog from '@/components/ModalDialog'
import { mapGetters } from 'vuex'
import CreateEdit from './components/CreateEdit.vue'

export default {
  name: 'CategoryList',
  components: {
    CreateEdit,
    PageHeaderLayout,
    TreeTable,
    ModalDialog
  },
  data() {
    return {
      loadingStatus: true,
      selectedList: [],
      dialogData: {
        visible: false,
        title: '',
        width: '40%',
        loading: true,
        modal: false
      },
      columns: [
        {
          title: 'ID',
          value: 'id',
          width: 120
        },
        {
          title: '图片',
          type: 'image',
          value: 'image_url',
          width: 60
        },
        {
          title: '分类名称',
          operation: true, // 作为展开操作列
          value: 'display_name',
          width: 180
        },
        {
          title: '分类标识',
          value: 'name'
        },
        {
          title: '排序',
          value: 'order'
        },
        {
          title: '备注',
          value: 'description'
        }

      ],
      // 表格列表数据
      categoryList: [],
      defaultFormData: {
        display_name: '',
        parent_id: 0
      },
      // 表单结构
      formData: {},
      // 已上传文件列表
      uploadFileList: [],
      // 表单验证
      rules: {
        display_name: [{ required: true, message: '输入分类名称', trigger: 'blur' }],
        name: [{ required: true, message: '输入分类标识', trigger: 'blur' }]
      }
    }
  },
  computed: {
    ...mapGetters(['userPermissions'])
  },
  methods: {
    // 响应添加按钮
    addButton(row) {
      this.$refs['refCreateEdit'].add(row)
    },
    // 响应编辑按钮
    editButton(row) {
      this.$refs['refCreateEdit'].edit(row)
    },
    handleDelete(row) {
      this.$confirm(`此操作将永久删除该数据【分类：${row.display_name}】, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteButton(row.id)

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 相应删除按钮
    async deleteButton(id) {
      const info = await this.$api.deleteCategoryInfo(id)
      if (info === 'ok') {
        await this.handleRefresh()
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      } else {
        this.$message.error(info)
      }
    },
    handleSavedEvent() {
      this.handleRefresh()
    },

    // 拖拽排序数据提交，请求接口
    async dragSortSubmit(orderIds) {
      const ids = this.$refs['treeTable'].getExpandIds()
      const info = await this.$api.orderCategory(orderIds)
      if (info === 'ok') {
        const { list } = await this.$api.getCategoryList()
        this.categoryList = []
        this.$nextTick(() => {
          this.categoryList = list
          this.$nextTick(() => {
            this.$refs['treeTable'].initTableExpand(ids)
          })
        })

      }
      this.$message.success('保存成功!')
    },
    // 表格拖拽排序，同层级移动有效果
    dragSort() {
      const el = document.querySelectorAll('.el-table__body-wrapper > table > tbody')[0]
      this.sortable = Sortable.create(el, {
        handle: '.drag-handle',
        setData: function(dataTransfer) {
          dataTransfer.setData('Text', '')
          // to avoid Firefox bug
          // Detail see : https://github.com/RubaXa/Sortable/issues/1012
        },
        onEnd: evt => {
          const oldId = evt.item.querySelectorAll('.drag-handle')[0].dataset.id
          const Ids = []
          const orderIds = []
          const newList = []
          const tmp = el.querySelectorAll('.drag-handle')
          for (let i = 0, len = tmp.length; i < len; i++) {
            newList[tmp[i].dataset.id] = { 'parent_id': tmp[i].dataset.parent_id, 'depth': tmp[i].dataset.depth }
            Ids.push(tmp[i].dataset.id)
          }
          // 处理组合实际请求后台数据
          for (let i = 0, len = Ids.length; i < len; i++) {
            if (newList[oldId].parent_id == newList[Ids[i]].parent_id && newList[oldId].depth == newList[Ids[i]].depth) {
              orderIds.push(Ids[i])
            }
          }
          this.dragSortSubmit(orderIds)
        }
      })
    },
    async handleQuery() {
      this.loadingStatus = true
      const { list } = await this.$api.getCategoryList()
      this.categoryList = list
      setTimeout(() => {
        this.loadingStatus = false
      }, 200)
    },
    // eslint-disable-next-line no-unused-vars
    handleRefresh() {
      this.handleQuery()
      // if (expandIds) {
      //   this.$nextTick(() => {
      //     this.$refs['treeTable'].initTableExpand(expandIds)
      //   })
      // }

      // this.loadingStatus = false
      // this.$nextTick(() => {
      //   this.dragSort()
      // })
    }
  },
  mounted() {
    this.handleRefresh()
  }
}
</script>

<style lang='scss'>
.el-button {
  margin-right: 4px;
  margin-bottom: 4px;
}

.table-header {
  margin-bottom: 12px;
}

.el-input-group__prepend, .el-input-group__append {
  background: #ffffff;
  padding: 0 12px;
}

.el-input-group__append {
  color: #ffffff;
  background: #1890ff;
}
</style>
